import {
  AdminModel,
  DashboardContainerInterface,
  DatatableBuilderInterface,
  DatatableTypeInterface,
  PaginationRequest,
  PROVIDER_NAMES,
  textFiltrable,
} from '@ckmk/angular';
import { Injectable, inject } from '@angular/core';
import {
  faCopy,
  faEye,
  faPenToSquare,
  faTrash,
  faTrashArrowUp,
} from '@fortawesome/free-solid-svg-icons';
import { PostCategoryModel } from '@app/src/app/modules/post/classes/category/model/post.category.model';

@Injectable()
export class PostCategoryDatatableType implements DatatableTypeInterface {
  protected readonly container = inject<DashboardContainerInterface>(
    PROVIDER_NAMES.DASHBOARD_CONTAINER,
  );

  public constructor() {}

  public async configure(
    builder: DatatableBuilderInterface<AdminModel>,
  ): Promise<void> {
    const auth = this.container.authService.auth() as AdminModel;

    builder
      .setAuth(auth)
      .addIdentifyColumn()
      .addActiveColumn({
        editableOptions: {
          guard: {
            permissions: ['PERMISSION_UPDATE_POST_CATEGORY'],
          },
        },
      })
      .add({
        type: 'file',
        name: 'cover',
        label: 'Cover',
        config: {
          editable: true,
          editableOptions: {
            guard: {
              permissions: ['PERMISSION_UPDATE_POST_CATEGORY'],
            },
          },
        },
      })
      .add({
        type: 'translation',
        name: 'title',
        label: 'Title',
        config: {
          sortable: true,
          editable: true,
          fixed: true,
          editableOptions: {
            guard: {
              permissions: ['PERMISSION_UPDATE_POST_CATEGORY'],
            },
          },
          filterable: textFiltrable({ translateAble: true }),
          inputs: {
            fieldConfig: {
              type: 'text',
            },
          },
        },
      })
      .add({
        type: 'text',
        name: 'slug',
        label: 'Slug',
        config: {
          sortable: true,
          editable: true,
          editableOptions: {
            guard: {
              permissions: ['PERMISSION_UPDATE_POST_CATEGORY'],
            },
          },
          filterable: textFiltrable(),
        },
      })
      .addTimestampsColumns(auth.timezone)
      .addBlameColumns()
      .withPayload({
        filters: [],
        pagination: new PaginationRequest(),
        sorts: { createdAt: 'DESC' },
        includeSoftDeleted: true,
        includeCover: true,
      })
      .withActions([
        {
          name: 'show',
          label: 'Show',
          icon: faEye,
          guard: {
            permissions: ['PERMISSION_READ_POST_CATEGORY'],
          },
          activeColor: 'var(--color-warning)',
          path: (sc: PostCategoryModel): any => [
            this.container.path('/posts/categories/show'),
            sc.id,
          ],
          filter: (sc: PostCategoryModel) => !sc.deletedAt,
        },
        {
          name: 'update',
          label: 'Update',
          icon: faPenToSquare,
          guard: {
            permissions: ['PERMISSION_UPDATE_POST_CATEGORY'],
          },
          activeColor: 'var(--color-success)',
          path: (sc: PostCategoryModel): any => [
            this.container.path('/posts/categories/update'),
            sc.id,
          ],
          filter: (sc: PostCategoryModel) => !sc.deletedAt,
        },
        {
          name: 'copy',
          label: 'Copy',
          icon: faCopy,
          guard: {
            permissions: ['PERMISSION_COPY_POST_CATEGORY'],
          },
          activeColor: 'var(--color-primary)',
          path: (sc: PostCategoryModel): any => [
            this.container.path('/posts/categories/copy'),
            sc.id,
          ],
          filter: (sc: PostCategoryModel) => !sc.deletedAt,
        },
        {
          name: 'delete',
          label: 'Delete',
          icon: faTrash,
          guard: {
            permissions: ['PERMISSION_DELETE_POST_CATEGORY'],
          },
          activeColor: 'var(--color-danger)',
          filter: (sc: PostCategoryModel) => !sc.deletedAt,
        },
        {
          name: 'restore',
          label: 'Restore',
          icon: faTrashArrowUp,
          guard: {
            roles: ['ROLE_DEV'],
          },
          activeColor: 'var(--color-danger)',
          filter: (sc: PostCategoryModel) => !!sc.deletedAt,
        },
      ])
      .saveToStorage();
  }
}
